import { create } from "zustand";
import axios from "axios";

const orderReturnRequestStore = create((set) => ({
  orderReturnRequest: null,
  isLoading: false,

  orderReturnRequestFilterApply: 0,

  setOrderReturnRequestFilterApply: ({ value }) => {
    set({ orderReturnRequestFilterApply: value });
  },

  fetchAllOrderReturnRequest: async () => {
    try {
      const res = await axios.get("/fetch-all-order-return-request");
      if (res.data.orderReturnRequest.length) {
        set({ orderReturnRequest: res.data.orderReturnRequest });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },

  updateReturningStatus: async ({ id, order_returning_status }) => {
    try {
      set({ isLoading: true });

      const res = await axios.put(`/update-order-return-request/${id}`, {
        order_returning_status,
      });

      set({ orderReturnRequest: res.data.orderReturnRequest });
      set({ isLoading: false });
    } catch (error) {
      set({ isLoading: false });
      console.log(error);
    }
  },

  updateReturningStatusForReturn: async ({
    id,
    order_returning_status,
    paymentID,
  }) => {
    try {
      set({ isLoading: true });

      const res = await axios.put(
        `/update-order-return-request-for-return/${id}`,
        {
          order_returning_status,
          paymentID,
        }
      );

      set({ orderReturnRequest: res.data.orderReturnRequest });
      set({ isLoading: false });
    } catch (error) {
      set({ isLoading: false });
      console.log(error);
    }
  },

  cancelReturnOrder: async ({ id }) => {
    try {
      set({ isLoading: true });

      const res = await axios.put(`/cancel-return-order/${id}`);

      set({ orderReturnRequest: res.data.orderReturnRequest });
      set({ isLoading: false });
    } catch (error) {
      set({ isLoading: false });
      console.log(error);
    }
  },
}));

export default orderReturnRequestStore;
